/* 车辆管理相关接口 */
import { $post } from '@/api/request'

// 通用申请
export function update (data = {}) {
  return $post({
    url: '/compApplyCommon/update',
    data
  })
}
// 通用申请
export function stagingApply (data = {}) {
  return $post({
    url: '/compApplyCommon/stagingApply',
    data
  })
}

// 查询自己创建的 
export function queryMine (data = {}) {
  return $post({
    url: '/compApplyCommon/listMine',
    data
  })
}

// 查询需要我审批的 
export function queryMyAudit (data = {}) {
  return $post({
    url: '/compApplyCommon/listWaitAudit',
    data
  })
}
// 查询已经审批的
export function listApplyAudited (data = {}) {
  return $post({
    url: '/compApplyCommon/listAudited',
    data
  })
}
// 发起用车申请
export function submitApply (data = {}) {
  return $post({
    url: '/compApplyCommon/submitApply',
    data
  })
}

// 获取详情 
export function getApplyDetail (data = {}) {
  return $post({
    url: '/compApplyCommon/getApplyDetail',
    data
  })
}
// 申请单催批 
export function sendSmsAuditPersonAgain (data = {}) {
  return $post({
    url: '/compApplyCommon/sendSmsAuditPersonAgain',
    data
  })
}
// 用车申请审核
export function audit (data = {}) {
  return $post({
    url: '/compApplyCommon/audit',
    data
  })
}
// 通用申请审核
export function auditAndNextUser (data = {}) {
  return $post({
    url: '/compApplyCommon/auditAndNextUser',
    data
  })
}
// 通用申请
export function stopUse (data = {}) {
  return $post({
    url: '/compApplyCommon/stopUse',
    data
  })
}